import Form from 'components/Profile/Preferences/Form';

const Preferences = () => <Form />;

export default Preferences;
